<template>
  <div>
    <!--汇总-->
    <Total style="min-height: 450px;"></Total>
    <!--交易统计-->
    <Transaction></Transaction>
  </div>
</template>

<script>
import StatisticsApi from "@/api/statistics.js";
import Total from "./part/Total.vue";
import Transaction from "./part/Transaction.vue";
export default {
  components: {
    Total,
    Transaction
  },
  data() {
    return {
      /*是否正在加载*/
      loading: true
    };
  },
  created() {},
  methods: {}
};
</script>

<style></style>



// WEBPACK FOOTER //
// src/views/statistics/sell/index.vue